import axios from "axios";

export const state = {
    insurancecompanies: [],
};

export const getters = {
    insurancecompanies: state => state.insurancecompanies,
};

export const mutations = {
    setInsurances(state, newValue) {
        state.insurancecompanies = newValue
    },
};

export const actions = {
    fetchInsurances({ commit }) {
        axios.get('/insurancecompanies').then(res => {
            commit('setInsurances', res.data.insurances)
        })
    },
};

